import React from "react";
import { Link } from "react-router-dom";

const CommonQuestionnaireCard = ({
  item,
  completed = false,
  admin = false,
  pending = false,
  previous = false,
  onDelete,
}) => {
  return (
    <div className="bg-white shadow-md flex flex-row items-center px-6 py-4 rounded-xl mt-2">
      <div className="flex flex-col">
        <p className="font-medium text-black text-base">{item?.name ?? ""}</p>
        <p className="text-slate-500 text-sm font-medium mt-1">
          <span className="font-semibold text-black">
            {item?.totalAnswered ?? 0}
          </span>{" "}
          of {item?.totalQuestions ?? 0} Questions Answered
        </p>
      </div>

      <div style={{ flex: 1 }} />

      {/* Show Complete Questionnaire Button to Users (Not Admin/Organisation) */}
      {!admin && !completed ? (
        <Link
          style={{ textDecoration: "unset" }}
          to="/questionnaires/answer"
          state={{ questionnaire: item }}
        >
          <div className="bg-mpPurple bg-opacity-20 px-6 py-4 rounded-xl">
            <p className="text-mpPurple font-medium text-sm">Complete</p>
          </div>
        </Link>
      ) : null}

      {/* Show Finalise Questionnaire Button to Organisation Admin Only */}
      {admin && !previous ? (
        <Link
          style={{ textDecoration: "unset" }}
          to={`/manager/questionnaires/edit/${item?._id}`}
        >
          <div className="bg-mpPurple bg-opacity-20 px-12 py-4 rounded-xl">
            <p className="text-mpPurple font-medium text-sm">Edit</p>
          </div>
        </Link>
      ) : null}

      {admin ? (
        <div
          onClick={() => onDelete(item?._id)}
          className="bg-red-300 ml-2 bg-opacity-20 px-9 py-4 rounded-xl cursor-pointer"
        >
          <p className="text-red-800 font-medium text-sm">Discard</p>
        </div>
      ) : null}

      {/* Show View Responses Button for Pending (Active) and Previous (Past) Questionnaires */}
      {pending || previous ? (
        <Link
          className="ml-2"
          style={{ textDecoration: "unset" }}
          to={`/manager/questionnaires/responses/${item?._id}`}
        >
          <div className="bg-slate-400 bg-opacity-20 px-6 py-4 rounded-xl">
            <p className="text-slate-700 font-medium text-sm">Responses</p>
          </div>
        </Link>
      ) : null}
    </div>
  );
};
export default CommonQuestionnaireCard;
